const Card2 = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 338 254"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      d="M1.00001 232.571L1 24.6948L42.8051 0.999999L336.495 0.999989L336.495 232.568L294.258 252.358L42.7663 252.358L1.00001 232.571Z"
      fill="url(#paint0_linear_83_675)"
      fillOpacity="0.7"
      stroke="url(#paint1_linear_83_675)"
      strokeWidth="2"
    />
    <clipPath
      id="card2-clippy"
      clipPathUnits="objectBoundingBox"
      transform="scale(0.0029585798816568,0.0039370078740157)"
      preserveAspectRatio="none"
    >
      <path
        d="M1.00001 232.571L1 24.6948L42.8051 0.999999L336.495 0.999989L336.495 232.568L294.258 252.358L42.7663 252.358L1.00001 232.571Z"
      />
    </clipPath>
    <defs>
      <linearGradient
        id="paint0_linear_83_675"
        x1="168.748"
        y1="-5.68391e-06"
        x2="168.748"
        y2="253.358"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.458807" stopColor="#050809" stopOpacity="0.45" />
        <stop offset="1" stopColor="#101129" stopOpacity="0.45" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_83_675"
        x1="-10.399"
        y1="-29.8703"
        x2="224.749"
        y2="311.819"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E728E8" />
        <stop offset="1" stopColor="#0228E8" />
      </linearGradient>
    </defs>
  </svg>
);
export default Card2;
